import React, { useEffect, useState } from "react";
import { Flex } from "../../components/Flex";
import { ArrowBackIcon } from "../../icons/ArrowBackIcon";
import styled from "styled-components";
import { TableContent } from "../../components/Table";
import { PACKAGE_STATUS } from "../../settings";
import { getTitle } from "../../utils";
import { sortBy } from "lodash";
import { Link } from "react-router-dom";
import { TextButton } from "../../components/Button";

const StyledCollapseHeader = styled(Flex).attrs({
    background: "#F0F4FB",
    padding: { left: "11px", top: "8px", right: "8px", bottom: "8px"},
    align: "center",
    gap: { right: 8 }
})`
    border-radius: ${({ expanded }) => expanded ? "8px 8px 0 0" : "8px"};
    cursor: pointer;
    color: var(--sp-main-color-hover);

    &:hover {
        color: var(--sp-main-color);
    }
`

const PackageAuditList = ({ getFullPackageAudit, data, selected, loading }) => {
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
       setExpanded(false);
    }, [selected]);

    useEffect(() => {
        if (expanded && !Array.isArray(data)) {
            getFullPackageAudit();
        }
    }, [expanded]);

    const columns = [
        {
            title: "Activity datetime",
            dataIndex: "activityDatetime",
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text, record) => record.auditNumber == selected ? getTitle(text, PACKAGE_STATUS) : <Link to={`/audit/packages/${record.auditNumber}`}>{getTitle(text, PACKAGE_STATUS)}</Link>,
        },
        {
            title: "Done By",
            dataIndex: "email",
        }
    ];


    return(
        <Flex id="package-full-audit" direction="column">
            <StyledCollapseHeader expanded={expanded}>
                <TextButton flex={1} disabled={loading} onClick={() => setExpanded(!expanded)}>
                    <ArrowBackIcon rotate={expanded ? 270 : 180}/>
                    <span>View the full history</span>
                </TextButton>
            </StyledCollapseHeader>
            <Flex id="audit-table-container" height={"calc(100% - 40px)"}>
                {expanded
                    ? <TableContent
                        dataSource={sortBy(data, ["activityDatetime"]).reverse()}
                        columns={columns}
                        loading={!Array.isArray(data)}
                    />
                    : null}
            </Flex>
        </Flex>
    )
}

export { PackageAuditList };